
import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./SubseaSettlementTank.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import { PumpContext } from "../context/PumpContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";

import { trackPageVisit } from "../competency/PageTracker";




function SubseaSettlementTank() {

        useEffect(() => {
  
    trackPageVisit("SubseaSettlementTank");
  
  }, []);

  
  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};


   const {  valves, toggleValve, transmitters} = useContext(WellContext);

  
    const [FIC_2916, setFIC_2916] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2916")) || 0;
            setFIC_2916(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

    const [PT_2915, setPT_2915] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2915")) || 0;
            setPT_2915(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);



    const FIC_2923 = FIC_2916;

    const PT_2923 = PT_2915;

    const PT_2925 =  PT_2923 * 0.998;

    const PT_2922 =  PT_2923 * 0.13;

    const FIC_2922 =  FIC_2923 * 0.13;

    
    const isXV2920Open = valves?.XV_2920 === false;

    const FIC_2924 =  isXV2920Open ? FIC_2923 * 0.68 : 0;

    const PT_2924 =  isXV2920Open ? PT_2923 * 0.13 : 0.03;

    


    // ================= PUMP P-2910 STATE =================
const { pumpData } = useContext(PumpContext);

const isP2920On = pumpData?.["P-2920"]?.running ?? false;


// ================= TARGET VALUES =================
const targetFlow = isP2920On ? 21.23 : 0;     // adjust max flow
const targetPressure = isP2920On ? 0.6 : 0; // adjust max pressure


// ================= STATES =================
const [FIC_2921, setFIC_2921] = useState(
  Number(localStorage.getItem("FIC_2924")) || 0
);

const [PT_2921, setPT_2921] = useState(
  Number(localStorage.getItem("PT_2921")) || 0
);


// ================= SMOOTH RESPONSE =================
useEffect(() => {
  const interval = setInterval(() => {

    // FLOW RESPONSE
    setFIC_2921(prev => {
      const error = targetFlow - prev;
      const gain = isP2920On ? 0.18 : 0.12; // faster up, slower decay
      const next = prev + error * gain;

      return Math.abs(next) < 0.01 ? 0 : Number(next.toFixed(2));
    });

    // PRESSURE RESPONSE
    setPT_2921(prev => {
      const error = targetPressure - prev;
      const gain = isP2920On ? 0.20 : 0.10; // pressure reacts slightly faster
      const next = prev + error * gain;

      return Math.abs(next) < 0.005 ? 0 : Number(next.toFixed(3));
    });

  }, 100); // fast DCS scan (no lag)

  return () => clearInterval(interval);

}, [targetFlow, targetPressure, isP2920On]);


// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("FIC_2921", FIC_2921);
}, [FIC_2921]);

useEffect(() => {
  localStorage.setItem("PT_2921", PT_2921);
}, [PT_2921]);



    useEffect(() => {
  localStorage.setItem("FIC_2923", FIC_2923);
}, [FIC_2923]);
     

     


  return (
    <div className="SubseaSettlementTank-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "236px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)",
        padding: "2px 340px"
      }}>
        SUBSEA SETTLEMENT TANK
      </h2>






       {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}



      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2920 */}
      <Valve
        className="XV-2920"
        tag="XV_2920"
        x={794}
        y={557}
        isClosed={valves.XV_2920}
        toggle={toggleValve}
      />


    

      
          {/* ================= TRANSMITTERS ================= */}

           <Transmitter
          tag="FIC-2923"
          value={[FIC_2923]}
          x={220}
          y={388}
          unit="LPM"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF TREATED WATER FROM SKIM PILE TO SUBSEA SETTLEMENT TANK"
        />
        <Transmitter
          tag="FIC-2924"
          value={[FIC_2924]}
          x={867}
          y={545}
          unit="LPM"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF TREATED WATER FROM SUBSEA SETTLEMENT TANK TO SEA BED"
        />
        <Transmitter
          tag="FIC-2923"
          value={[FIC_2923]}
          x={145}
          y={388}
          unit="LPM"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF TREATED WATER FROM SKIM PILE TO SUBSEA SETTLEMENT TANK"
        />

        <Transmitter
          tag="PT-2924"
          value={PT_2924}
          x={952}
          y={545}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF TREATED WATER FROM SUBSEA SETTLEMENT TANK TO SEA BED"
        />

        
         <Transmitter
          tag="FIC-2921"
          value={[FIC_2921]}
          x={252}
          y={79}
          unit="LPM"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF RECOVERED CRUDE OIL TO OILY WATER TANK"
        />

        
        <Transmitter
          tag="PT-2921"
          value={PT_2921}
          x={339}
          y={79}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF RECOVERED CRUDE OIL TO OILY WATER TANK"
        />


        <Transmitter
          tag="PT-2925"
          value={PT_2925}
          x={436}
          y={386}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SETTLEMENT TANK INTERNAL PRESSURE"
        />


        <Transmitter
          tag="PT-2922"
          value={PT_2922}
          x={910}
          y={216}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF RECOVERED GAS FROM SUBSEA SETTLEMENT TANK TO FLARE HEADER"
        />

         <Transmitter
          tag="FIC-2922"
          value={[FIC_2922]}
          x={834}
          y={216}
          unit="SCF/S"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF RECOVERED GAS FROM SUBSEA SETTLEMENT TANK TO FLARE HEADER"
        />



          
    <LevelTransmitterIndicator
      tag="LT_2921"
      totalLevel={50000}
      inflows={[(FIC_2923)*0.3]}
      outflows={[FIC_2921]}
      responseFactor={0.05}
      columnX={635}
      columnY={270}
      columnWidth={30}
      columnHeight={158}
      textX={705}
      textY={290}
      showFlow={true}
    />
          
    <LevelTransmitterIndicator
      tag="LT_2922"
      totalLevel={90000}
      inflows={[(FIC_2923)*0.66]}
      outflows={[FIC_2924]}
      responseFactor={0.05}
      columnX={635}
      columnY={428}
      columnWidth={30}
      columnHeight={188}
      textX={774}
      textY={420}
      showFlow={true}
    />


    
    <Pump
      tag="P-2920"
      x={606}
      y={99}
      rpm={1800}
      bladeCount={pumpData?.["P-2920"]?.bladeCount || 3}
      size={pumpData?.["P-2920"]?.size || 37}
      onClick={openPumpPanel}
    />

   






    </div>
  );
}

export default SubseaSettlementTank;